import React, { useState } from "react";

const EXPERIMENTS = [
  { label: "Three-breath pause before replying to one difficult message." },
  { label: "Eat the first three bites of one meal with full attention." },
  { label: "Notice one moment of joy today and name it silently." },
  {
    label:
      "When you feel triggered, silently say, 'This is hard — and I am here.'",
  },
  { label: "Spend five minutes outside, simply sensing without your phone." },
];

export default function ExperimentsTab() {
  const [rows, setRows] = useState(
    EXPERIMENTS.map((e) => ({ ...e, done: false }))
  );
  const toggle = (i) =>
    setRows((r) =>
      r.map((x, idx) => (idx === i ? { ...x, done: !x.done } : x))
    );

  return (
    <section className="card lg section">
      <div className="section-head">
        <h2 className="h2">Try It and See</h2>
        <span className="xs muted">
          No success or failure — just experiments in being alive.
        </span>
      </div>

      <ul style={{ margin: 0, paddingLeft: 18 }}>
        {rows.map((r, i) => (
          <li key={i} className="sm" style={{ marginBottom: 4 }}>
            <label style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <input
                type="checkbox"
                checked={r.done}
                onChange={() => toggle(i)}
              />
              <span style={{ textDecoration: r.done ? "line-through" : "" }}>
                {r.label}
              </span>
            </label>
          </li>
        ))}
      </ul>
    </section>
  );
}
